import styled from 'styled-components'
import SimpleSelect from '../SimpleSelect/SimpleSelect'

export const DatePickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`
export const DatePickerWrapperHeader = styled.div`
  z-index: 0;
  position: relative;
  display: flex;
  gap: 20px;
  width: 100%;

  padding: 15px 20px;

  font-size: 16px;
  border-radius: 10px;
  font-weight: 400;
  box-shadow: none;

  border: ${({ theme }) => `1px solid ${theme.colors.borderColor}`};

  background-color: ${({ disabled, theme }) => (disabled ? 'transparent' : theme.colors.backgroundLite)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: ${({ open }) => (open ? '10px 10px 0 0' : '10px')};
  /* box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.07); */
`
export const DatePickerDate = styled.div`
  color: ${({ theme }) => theme.colors.primary};
`

export const Label = styled.label`
  position: relative;
  z-index: 1;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;
  padding: 0 8px;
  transform: translate(15px, 15px);

  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
  width: fit-content;
`

export const DatePickerContainer = styled.div`
  z-index: ${({ open }) => (open ? 10 : 0)} !important;
  top: 100%;
  position: absolute;
  height: ${({ open }) => (open ? 'fit-content' : 0)} !important;
  padding: ${({ open }) => (open ? '20px' : '0 20px')} !important;
  overflow: ${({ open }) => (open ? 'visible' : 'hidden')} !important;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ open, theme }) => (open ? `${theme.colors.backgroundLite}` : `${theme.colors.backgroundLite}00`)};
  transition: 0.3s;

  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background};
  width: fit-content;
  border-radius: 10px;
  box-shadow: ${({ open }) => open && '0px 0px 7px rgb(0 0 0 / 10%)'};
`
export const DatePickerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: fit-content;

  & button {
    min-height: 30px;
    min-width: 30px;
    padding: 5px;
    border: none;
    & svg {
      max-width: 100% !important;
      max-height: 100% !important;
    }
    &:hover {
      border: none;
      background-color: ${({ theme }) => theme.colors.brand};
    }
  }
`
export const DateChangerWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;

  & div {
    margin: 0 !important;
    font-size: 12px !important;
  }
`
export const DateChanger = styled(SimpleSelect)``
export const DateChangerContainer = styled.div`
  display: flex;
  width: 100%;

  & > div > div > div:last-child {
    max-height: 200px;
    & div > div {
      padding: 3px 5px;
    }
  }
`

export const DateContentWrapper = styled.div`
  display: flex;
  gap: 30px;
`
export const DateGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0 0 0;
`
export const DateGroupTitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.primary};
`
export const DateWeekWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px !important;
`
export const DateDayWrapper = styled.div`
  display: grid !important;
  grid-template-columns: repeat(7, minmax(20px, 1fr)) !important;
  gap: 10px !important;
`
export const DateDayContainer = styled.div`
  font-size: 12px;
  text-align: center;
  color: ${({ theme, disabled }) => (disabled ? `${theme.colors.secondary} !important` : theme.colors.primary)};
  color: ${({ theme, active }) => active && theme.colors.background};
  cursor: pointer;

  padding: 3px 5px;
  border-radius: 5px;
  text-decoration: ${({ forbidden }) => forbidden && 'line-through'};

  background-color: ${({ active, theme }) => active && theme.colors.brand};
  background-color: ${({ disabled }) => disabled && 'transparent !important'};
  &:hover {
    background-color: ${({ disabled, theme }) => !disabled && theme.colors.secondary};
  }
`
